import { fg } from '@atlaskit/platform-feature-flags';

import {
	treatmentCohortTransformFn,
	useGetExperimentValue,
} from '../../../services/experiment-context';
import type { ExperimentCohort, Product } from '../../../types';

export const useNBEAExperiment = ({
	fireExperimentExposure = false,
	product,
}: {
	fireExperimentExposure: boolean;
	product: Product;
}): {
	abCohort: ExperimentCohort;
	abExperimentKey: string;
} => {
	const abExperimentKey = 'confluence_next_best_edition_recommend';
	let abCohort: ExperimentCohort = 'not-enrolled';

	const { getExperimentValueWithTransform } = useGetExperimentValue();

	if (product === 'confluence' && fg('edition_awareness_confluence_next_best_rec_fg')) {
		abCohort = getExperimentValueWithTransform<ExperimentCohort>({
			statsigParams: {
				experimentName: abExperimentKey,
				parameterName: 'cohort',
				defaultValue: 'not-enrolled',
				options: { fireExperimentExposure },
			},
			transformCohortFunc: treatmentCohortTransformFn,
		});
	}

	return {
		abExperimentKey,
		abCohort,
	};
};
